export default __webpack_public_path__ + "static/media/artwork.10525588.png";